import { V_URL_API } from "../../../../../../../utils/config";

export async function getQuoteMarketing(ids = null, vToken) {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `E ${vToken}`);
  myHeaders.append("Content-Type", "application/json");

  // Construir la URL, añadiendo el query parameter si 'ids' está definido
  const url = ids 
    ? `${V_URL_API}/api/quote_marketing?ids=${ids}` 
    : `${V_URL_API}/api/quote_marketing`;

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
  };

  return await fetch(url, requestOptions);
}
